import { localeInitial } from './locale';
import { screenInitial } from './screen';
import { userInitial } from './user';
import type { GlobalContextReducerState } from './types';
import { activeFeatureConfigInitial } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';
import { currentVRCountryInitial } from './currentVRCountry';
import { coBrandDetailsInitial } from './coBrandDetails';

export const defaultState: GlobalContextReducerState = {
  screen: screenInitial,
  locale: localeInitial,
  user: userInitial,
  activeFeatureConfig: activeFeatureConfigInitial,
  portal: Portal.PARTNER,
  currentVRCountry: currentVRCountryInitial,
  coBrandDetails: coBrandDetailsInitial
};
